module.exports = __webpack_public_path__ + "img/expenditure.8264956c.svg";